import { useQuery } from '@tanstack/react-query'
import { RoutineService } from '../../services/routineService'
import { queryKeys } from '../queryKeys'
import { useUserCredentials } from './useCredentials'
import type { Routine } from '../../types'

export const useRoutines = () => {
  const { data: userCredentials, isLoading } = useUserCredentials()

  // Only run if user has a valid API key
  const hasValidApiKey =
    userCredentials?.apiKey &&
    userCredentials.apiKey !== 'CSV_IMPORT' &&
    userCredentials.apiKey.length > 10

  return useQuery({
    queryKey: queryKeys.routines(userCredentials?.apiKey || ''),
    queryFn: async (): Promise<Routine[]> => {
      if (!userCredentials?.apiKey) {
        throw new Error('Routines require a configured Hevy API Key.')
      }

      return RoutineService.fetchAllRoutines(userCredentials.apiKey)
    },
    enabled: !isLoading && !!hasValidApiKey,
    retry: false // Don't retry failed API calls
  })
}
